<template>
    <v-container class="mb-4 tableContainer">
        <v-row class="tableTitle">
            {{ title }}
        </v-row>
        <v-row v-for="data in cellData" :key="data.id">
            <template v-if="data.arrayType === 'playStyle'">
                <v-col cols="3">
                    {{ data.name }}
                </v-col>
                <v-col cols="9">
                    <template v-if="data.value.meal_flag === 0">
                        <div :class="{ 'icon_meal_no': Boolean(!data.value.meal_flag)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.meal_flag === 1">
                        <div :class="{ 'icon_meal_yes': Boolean(data.value.meal_flag)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.caddie_flag === 0">
                        <div :class="{ 'icon_caddie_no': Boolean(!data.value.caddie_flag)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.caddie_flag === 1">
                        <div :class="{ 'icon_caddie_yes': Boolean(data.value.caddie_flag)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.cart_code === 1">
                        <div :class="{ 'icon_cart_auto2': Boolean(data.value.cart_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.cart_code === 2">
                        <div :class="{ 'icon_cart_auto4': Boolean(data.value.cart_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.cart_code === 3">
                        <div :class="{ 'icon_cart_auto': Boolean(data.value.cart_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.cart_code === 4">
                        <div :class="{ 'icon_cart_manual': Boolean(data.value.cart_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.cart_code === 5">
                        <div :class="{ 'icon_cart_use1': Boolean(data.value.cart_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.cart_code === 6">
                        <div :class="{ 'icon_cart_use2': Boolean(data.value.cart_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.cart_code === 7">
                        <div :class="{ 'icon_cart_use3': Boolean(data.value.cart_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.cart_code === 8">
                        <div :class="{ 'icon_cart_use4': Boolean(data.value.cart_code)}" class="icon_class"></div>
                    </template>
                    <!--
                    <template v-if="data.value.some_code === 1">
                        <div :class="{ 'icon_guarantee_no': Boolean(data.value.some_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.some_code === 2">
                        <div :class="{ 'icon_guarantee_2b': Boolean(data.value.some_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.some_code === 3">
                        <div :class="{ 'icon_guarantee_3b': Boolean(data.value.some_code)}" class="icon_class"></div>
                    </template>
                    -->
                    <template v-if="data.value.some_code === 0">
                        <div :class="{ 'icon_guarantee_yes': Boolean(!data.value.some_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.some_code === 1">
                        <div :class="{ 'icon_guarantee_no': Boolean(data.value.some_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.round_code === 1">
                        <div :class="{ 'icon_round_9h': Boolean(data.value.round_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.round_code === 2">
                        <div :class="{ 'icon_round_18h': Boolean(data.value.round_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.round_code === 3">
                        <div :class="{ 'icon_round_27h': Boolean(data.value.round_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.round_code === 4">
                        <div :class="{ 'icon_round_36h': Boolean(data.value.round_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.round_code === 5">
                        <div :class="{ 'icon_round_free': Boolean(data.value.round_code)}" class="icon_class"></div>
                    </template>

                    <!--<div :class="{ 'icon_accommodation_yes': data.value.accommodation_flag, 'icon_accommodation_no': !data.value.accommodation_flag }" class="icon_class"></div>-->
                    <template v-if="data.value.accommodation_flag === 0">
                        <div :class="{ 'icon_accommodation_no': Boolean(!data.value.accommodation_flag)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.accommodation_flag === 1">
                        <div :class="{ 'icon_accommodation_yes': Boolean(data.value.accommodation_flag)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.some_code === 0">
                        <div :class="{ 'icon_share_no': Boolean(!data.value.some_code)}" class="icon_class"></div>
                    </template>
                    <template v-if="data.value.some_code === 1">
                        <div :class="{ 'icon_share_yes': Boolean(data.value.some_code)}" class="icon_class"></div>
                    </template>
                    <!--<div :class="{ 'icon_guarantee_3b': data.value.through_flag, 'icon_dummy': !data.value.through_flag }" class="icon_class"></div>-->
                    <!--<div :class="{ 'icon_accommodation_yes': data.value.lesson_flag, 'icon_accommodation_no': !data.value.lesson_flag }" class="icon_class"></div>-->
                </v-col>
            </template>
            <template v-else-if="data.three">
                <v-col cols="1">
                    <template v-if="data.first">
                        割増料金
                    </template>
                </v-col>
                <v-col cols="2" class="text-right">
                    {{ data.name }}
                </v-col>
                <v-col cols="9">
                    {{ data.value }}
                </v-col>
            </template>
            <template v-else>
                <v-col cols="3">
                    {{ data.name }}
                </v-col>
                <v-col cols="9" class="wordBreak">
                    {{ data.value }}
                </v-col>
            </template>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        cellData: {
            Type: Array,
            required: true
        }
    }
};
</script>

<style scoped>

.title{
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 5px;
}

.v-application .title {
    line-height: 3rem;
}

.titleContainer{
    padding-right: 40px;
    padding-left: 40px;
}

.tableTitle{
    padding: 10px;
    border: solid 1px rgba(0,0,0, 0.12);
    border-radius: 10px;
    font-size: 20px;
    font-weight: bold;
}

.tableContainer{
    padding-right: 40px;
    padding-left: 40px;
}

.tableContainer .col{
    border: 1px solid rgba(0, 0, 0, 0.12);
}
.wordBreak {
    white-space: pre-wrap;
    word-break: break-word;
}

</style>
